import styled from 'styled-components'
import { Pagination } from 'antd'

export const CustomPagination = styled(Pagination)`
  text-align: center;
  margin-top:15px;
`
